import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, initializeAuth, indexedDBLocalPersistence } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider, CustomProvider, getToken } from "firebase/app-check";
import { Capacitor } from "@capacitor/core";
import { FirebaseAppCheck } from "@capacitor-firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyBPJ-HfHwAeQfKZw9KhZ7dtz0sAvrHrsWk",
  authDomain: "whatif-battle-for-riches.firebaseapp.com", // Verify this
  projectId: "whatif-battle-for-riches",                  // Verify this
  storageBucket: "whatif-battle-for-riches.firebasestorage.app",
  messagingSenderId: "1061497822365",
  appId: "1:1061497822365:web:f81fec67338c7c95e48874",
  measurementId: "G-DW2VBXMG9J"
};
const app = initializeApp(firebaseConfig);

// Enable debug token for non-production environments
if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Initialize native App Check if on native platform
let nativeAppCheckInitPromise = null;
if (Capacitor.isNativePlatform()) {
  nativeAppCheckInitPromise = FirebaseAppCheck.initialize({
    debugToken: false,
    isTokenAutoRefreshEnabled: true,
  }).catch((e) => {
    console.warn("[AppCheck] Failed to initialize native FirebaseAppCheck:", e);
  });
}

// Initialize App Check based on the platform
let appCheck;

if (Capacitor.isNativePlatform()) {
  // ANDROID/IOS NATIVE: Use the Custom Provider to fetch the Play Integrity Token
  appCheck = initializeAppCheck(app, {
    provider: new CustomProvider({
      getToken: async () => {
        try {
          if (nativeAppCheckInitPromise) {
            await nativeAppCheckInitPromise;
          }
          let result = await FirebaseAppCheck.getToken();
          if (!result || !result.token) {
            console.warn("[AppCheck] Empty token received, forcing refresh...");
            result = await FirebaseAppCheck.getToken({ forceRefresh: true });
          }
          return {
            token: result.token,
            expireTimeMillis: result.expireTimeMillis,
          };
        } catch (error) {
          console.error("[AppCheck] Failed to fetch native App Check token:", error);
          // Throwing lets App Check back off and retry later. An already-expired token would make it ask again at once, in a tight loop.
          throw error;
        }
      },
    }),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  // WEB BROWSER: Use the standard reCAPTCHA v3 Provider
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LfFGkssAAAAAJYQJdrZ-N2mFO901pK_AbRcpr-a"),
    isTokenAutoRefreshEnabled: true,
  });
}

if (appCheck) {
  getToken(appCheck, false).then(() => {
    console.log('[AppCheck] Token acquired :: UPLINK SECURE');
  }).catch(err => {
    console.warn('[AppCheck] Token probe warning:', err.message);
  });
}

const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

export { app, db, auth, functions, appCheck };